import axiosClient from './axiosClient'

const accountApi = {
  login: (payload) => axiosClient.post('/api/admin/sign-in', payload),
  logout: (payload) => axiosClient.post('/api/admin/sign-out', payload),
}

export default accountApi
